/**
 * CAD Session Utilities
 *
 * Session-scoped operations for the CAD workbench store (`useAppStore`).
 *
 * RETIRED (2026-09-15): the legacy document I/O this file used to provide
 * (`saveProject` / `loadProject` / `exportProject` with its own pre-envelope
 * `YapProject` schema) is gone. Document persistence now flows exclusively
 * through `ProjectFileIO.ts` + `services/fileSystem/*`, and format exports
 * through the canonical `file.export` runner (sheetCommands) and the BIM
 * `GeometryExporter` — one pipeline, one on-disk schema.
 */

import { useAppStore } from '../state/store';

/**
 * New project (clear the CAD session): drop every entity through the store
 * API (so the scene ledger mirrors the deletions), clear selection and reset
 * the camera to the default framing.
 */
export function newProject(): void {
    const store = useAppStore.getState();

    // Clear entities
    Object.keys(store.entities).forEach((id) => {
        store.deleteEntity(id);
    });

    // Clear selection
    store.clearSelection();

    // Reset view
    store.updateView({
        camera: {
            position: [10, 10, 10] as [number, number, number],
            target: [0, 0, 0] as [number, number, number],
            up: [0, 1, 0] as [number, number, number],
            fov: 50,
            near: 0.1,
            far: 1000,
        },
    });
}
